import { AuthProvider } from "./authContext";
import { UserProvider } from "./userContext";
// Add your providers in providerlist to access it anywhere in app 
export const providers = [AuthProvider , UserProvider];
